import { render, staticRenderFns } from "./editor_template_element_viewer.vue?vue&type=template&id=72fa6e53&scoped=true"
import script from "./editor_template_element_viewer.vue?vue&type=script&lang=js"
export * from "./editor_template_element_viewer.vue?vue&type=script&lang=js"
import style0 from "./editor_template_element_viewer.vue?vue&type=style&index=0&id=72fa6e53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fa6e53",
  null
  
)

export default component.exports